// @flow

import * as React from 'react';
import type { Element } from 'react';
import { connect } from 'react-redux';
import { MainActions } from '@adactive/arc-map';
import { WayFindingControlsActions } from '@adactive/adsum-wayfindingcontrols-asia';

import './levelControls.css';

import type { AppStateType } from '../../../../rootReducer';

type MappedStatePropsType = {|
    currentFloor: number
|};

type MappedDispatchPropsType = {|
    changeFloor: (floorId: number) => void,
    resetMapAndWayFinding: () => void,
|};

type OwnPropsType = {|
    allFloors: [object],
    userFloor: object,
    pathDrawing: boolean,
|};

type PropsType = MappedStatePropsType & OwnPropsType & MappedDispatchPropsType;

const LevelButton = (props: LevelButtonPropsType): Element<'div'> => {
    const {
        name, id, onClick, currentLevelId,
    } = props;

    if (currentLevelId === id) {
        return (
            name
                ? (
                    <div className="level-btn-active" id={id} onClick={onClick}>
                        {name}
                    </div>
                )
                : null
        );
    }
    return (
        name
            ? (
                <div className="level-btn" id={id} onClick={onClick}>
                    {name}
                </div>
            )
            : null
    );
};

class LevelControls extends React.Component<PropsType> {
    getLevels = () => {
        const { allFloors } = this.props;
        return Array.from(allFloors).map(floor => floor[1]);
    }

    onLevelClick = (e) => {
        const { changeFloor, resetMapAndWayFinding, pathDrawing } = this.props;
        if (!pathDrawing) {
            changeFloor(parseInt(e.target.id, 10));
            resetMapAndWayFinding(true, false, false, true);
        }
    }

    renderLevelButtons(): Element<any> {
        const { userFloor, currentFloor } = this.props;
        const levels = this.getLevels();

        return levels.map((level) => {
            if (level === userFloor) {
                return (
                    <div className="level-btn-wrapper" key={level.id}>
                        <LevelButton
                            name={level.name}
                            id={level.id}
                            onClick={this.onLevelClick}
                            currentLevelId={currentFloor}
                        />
                    </div>
                );
            }
            return (
                <div className="level-btn-wrapper" key={level.id}>
                    <LevelButton
                        name={level.name}
                        id={level.id}
                        onClick={this.onLevelClick}
                        currentLevelId={currentFloor}
                    />
                </div>
            );
        });
    }

    render(): Element<'div'> {
        return (
            <div className="levels-container">
                {this.renderLevelButtons()}
            </div>
        );
    }
}

const mapStateToProps = (state: AppStateType) => ({
    currentFloor: state.map.currentFloor,
});

const mapDispatchToProps = (dispatch: *): MappedDispatchPropsType => ({
    changeFloor: (floorId: number): void => dispatch(MainActions.changeFloorAction(floorId)),
    resetMapAndWayFinding: (reset, resetMap, resetMapAnimatedOption, resetWayfinding) => {
        dispatch(WayFindingControlsActions.resetMapAndWayFinding(
            reset,
            resetMap,
            resetMapAnimatedOption,
            resetWayfinding
        ));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelControls);



// WEBPACK FOOTER //
// ./src/components/MapControls/subComponents/LevelControls/LevelControls.js